import { mapDerivativeQuestionsHttpModelToStoreModel } from '@examdojo/question';
import { QuestionBankStoreModel } from './question-bank-store.model';
import { QuestionBankQuestionHttpModel } from './quetion-bank-http.model';

export function mapQuestionBankQuestionHttpModelToStoreModel(
  questionBankQuestionHttpModel: QuestionBankQuestionHttpModel,
): QuestionBankStoreModel {
  const baseModel = mapDerivativeQuestionsHttpModelToStoreModel(questionBankQuestionHttpModel);

  return {
    ...baseModel,
    awarded_marks: questionBankQuestionHttpModel.awarded_marks ?? null,
    grading_result: questionBankQuestionHttpModel.grading_result ?? null,
  };
}
